import { BaseFieldModel, IBaseFieldModel } from '../base/blueprint-field-base.model';

export interface IFieldUserModel extends IBaseFieldModel {
  isRequired: boolean;
  isReadOnly: boolean;
  value: string;
}

export class FieldUserModel extends BaseFieldModel implements IFieldUserModel {
  constructor(
    public isRequired: boolean,
    public isReadOnly: boolean,
    public value: string,
  ) {
    super(isRequired, isReadOnly);
  }
}
